// Decision 87: the ONE card every dashboard tile uses, modelled on the Evening wrap-up tile
// (mockups/business-dashboard.html). A tinted header strip holds the tile's title on the left and
// its count, status or one action on the right; the body below fills the rest and pins `actions` to
// the bottom, so buttons line up across a row. The card fills its grid cell, so tiles side by side
// are one height. No tile on the dashboard draws its own card.
//
// title: the tile's name (Poppins 700, --text-dcard-title: 20px, 18px on a phone; the same on every
// tile). tint: a palette token for the strip. meta: the strip's right side. actions: the bottom row.
import React from 'react';
import { v } from './tokens';
import './v2.css';

const cx = (...p) => p.filter(Boolean).join(' ');

export function DashboardCard({ title, tint = 'pastel-neutral', meta = null, actions = null, titleAs: Title = 'h2', className, children, ...rest }) {
  return (
    <article className={cx('ui-dcard', className)} data-dashboard-card="" {...rest}>
      <div className="ui-dcard__bar" style={{ '--ui-bg': v(tint) }}>
        <Title className="ui-dcard__title">{title}</Title>
        {meta && <div className="ui-dcard__meta">{meta}</div>}
      </div>
      <div className="ui-dcard__body">
        {children}
        {actions && <div className="ui-dcard__actions">{actions}</div>}
      </div>
    </article>
  );
}
